import { Injectable } from '@angular/core';
import { InterpolateFunction, InterpolationParameters, TranslateParser } from '@ngx-translate/core';

@Injectable()
export class CustomTranslateParser extends TranslateParser {
  // Default template matcher for {{}} syntax
  #defaultTemplateMatcher = /{{\s?([^{}\s]*)\s?}}/g;
  // Template matcher for [] syntax
  #customTemplateMatcher = /\[\s?([^[\]\s]*)\s?]/g;

  interpolate(expr: InterpolateFunction | string, params?: InterpolationParameters): string {
    if (typeof expr === 'string') {
      if (!params) {
        return expr;
      }
      // Custom interpolation logic using [] or {{}} syntax
      // First try to match [] syntax
      const customMatch = expr.match(this.#customTemplateMatcher);
      if (customMatch) {
        return this.#interpolateString(expr, params, this.#customTemplateMatcher);
      }
      // If no [] syntax, try to match {{}} syntax
      return this.#interpolateString(expr, params, this.#defaultTemplateMatcher);
    }
    if (typeof expr === 'function') {
      return expr(params);
    }
    return undefined;
  }

  #interpolateString(expr: string, params: InterpolationParameters, templateMatcher: RegExp) {
    return expr.replace(templateMatcher, (match: string, key: string) =>
      params[key] !== undefined ? params[key] : match,
    );
  }
}
